(function () {
  'use strict';
  const root = document.querySelector('[data-esv-search]');
  if (!root || !window.EsvGroupedSearch || !window.EsvSearchStorefront || !window.EsvSearchGuide) return;
  const core = window.EsvGroupedSearch;
  const guide = window.EsvSearchGuide;
  const $ = selector => root.querySelector(selector);
  const escape = value => String(value ?? '').replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char]);
  const currency = root.dataset.currency || 'EUR';
  const collectionHandle = root.dataset.collectionHandle || '';
  const vehicleSessionKey = 'esv:parts:vehicle';
  let collectionCategory = null, collectionIds = null;
  let categoryImages = {};
  try { categoryImages = JSON.parse($('[data-category-images]')?.textContent || '{}'); } catch (_) { /* Categories work without images. */ }
  const option = (value, label) => `<option value="${escape(value)}">${escape(label)}</option>`;
  let source, fullCatalog, categories, products = [], groups = [], sequence = 0, controller;
  let refreshed = false;
  let state = {}, selectedBrand = '', editingVehicle = false;
  let cached = null;
  let requestDraft = '';
  let loadingTimer;
  function loading(message) {
    clearTimeout(loadingTimer);
    $('[data-loading]').hidden = !message;
    if (!message) return;
    $('[data-loading-message]').textContent = message;
    $('[data-loading-detail]').textContent = 'Bitte bleib kurz auf dieser Seite.';
    loadingTimer = setTimeout(() => {
      $('[data-loading-detail]').textContent = 'Es dauert etwas länger. Wir laden weiterhin Ersatzteile aus unserem Sortiment.';
    }, 8000);
  }
  const pickers = [];

  function previewUrl(url) {
    if (root.dataset.theme) url.searchParams.set('preview_theme_id', root.dataset.theme);
    else url.searchParams.delete('preview_theme_id');
    return url;
  }

  function readState() {
    const params = new URL(location.href).searchParams;
    state = { query: (params.get('q') || '').slice(0, 200), vehicle: params.get('esv_vehicle') || '',
      inquiry: params.get('esv_inquiry') === '1', inquiryVehicle: (params.get('esv_inquiry_vehicle') || '').slice(0, 200),
      category: params.get('esv_category') || '', type: params.get('esv_type') || '',
      family: params.get('esv_family') || '', tire: guide.kinds.some(k => k.id === params.get('esv_tire')) ? params.get('esv_tire') : '',
      skipGuide: params.get('esv_guide') === 'skip', vehicleOff: params.get('esv_vehicle_off') === '1',
      stock: params.get('esv_stock') === '1',
      sort: params.get('esv_sort') === 'title' ? 'title' : 'relevance', page: Math.max(1, Math.floor(Number(params.get('esv_page')) || 1)) };
  }

  function syncUrl(replace = false) {
    const url = new URL(location.href);
    url.searchParams.delete('page');
    url.searchParams.delete('esv_max');
    const values = { q: state.query, type: 'product', esv_vehicle: state.vehicle, esv_category: state.category,
      esv_family: state.family, esv_tire: state.tire, esv_guide: state.skipGuide ? 'skip' : '', esv_vehicle_off: state.vehicleOff ? '1' : '',
      esv_type: state.type, esv_stock: state.stock ? '1' : '',
      esv_sort: state.sort === 'relevance' ? '' : state.sort, esv_page: state.page === 1 ? '' : state.page };
    for (const [key, value] of Object.entries(values)) {
      if (value) url.searchParams.set(key, value);
      else url.searchParams.delete(key);
    }
    history[replace ? 'replaceState' : 'pushState']({}, '', previewUrl(url));
    updateNative();
    updateRequest();
  }

  function updateRequest() {
    const body = $('#esv-request-body');
    if (!body) return;
    const vehicle = source?.vehicles.find(value => value.id === state.vehicle);
    const filters = [(categories || []).find(category => category.id === state.category)?.label, state.type,
      guide.kinds.find(kind => kind.id === state.tire)?.label, state.stock ? 'nur verfügbare Teile' : ''].filter(Boolean);
    const draft = ['Hallo, ich suche ein Ersatzteil.', '', `Suche: ${state.query || 'ohne Suchbegriff'}`,
      `Scooter: ${state.inquiry ? (state.inquiryVehicle || 'Bitte Marke und Modell ergänzen') + ' (noch nicht zugeordnet)' : vehicle?.label || 'noch nicht ausgewählt'}`,
      ...(filters.length ? [`Filter: ${filters.join(', ')}`] : []), '', 'Könnt ihr mir bei der Suche nach dem passenden Teil helfen?'].join('\n');
    // Keep a customer's edits, including text returned after a validation error.
    if (!body.value || body.value === requestDraft) body.value = draft;
    requestDraft = draft;
    const back = new URL(location.href);
    back.searchParams.delete('contact_posted');
    back.searchParams.delete('form_type');
    previewUrl(back);
    back.hash = 'EsvPartRequest';
    $('#EsvPartRequest [name="return_to"]').value = back.pathname + back.search + back.hash;
  }

  function updateNative() {
    const url = new URL(collectionHandle ? root.dataset.collectionUrl : root.dataset.searchUrl, location.origin);
    if (!collectionHandle) {
      url.searchParams.set('q', state.query);
      url.searchParams.set('type', 'product');
    }
    url.searchParams.set('view', 'esv-native');
    previewUrl(url);
    $('[data-native]').href = url.href;
    if (collectionHandle) $('[data-native]').textContent = 'Zur klassischen Kategorieansicht';
    root.querySelectorAll('[data-ask-ai]').forEach(link => {
      const ai = new URL(link.href, location.origin);
      previewUrl(ai);
      link.href = ai.href;
    });
  }

  function rememberVehicle() {
    if (window.EsvPartsVehicle) { window.EsvPartsVehicle.set(state.vehicle, 'results'); return; }
    try { sessionStorage.setItem(vehicleSessionKey, state.vehicle); } catch (_) { /* URL state still works. */ }
  }

  async function json(url, signal) {
    const response = await fetch(url, { credentials: 'same-origin', signal: signal ? AbortSignal.any([signal, AbortSignal.timeout(30000)]) : AbortSignal.timeout(30000) });
    if (!response.ok) throw new Error('Request failed');
    return response.json();
  }

  function vehicleOptions(brandId, selected = '') {
    const models = source.vehicles.filter(vehicle => vehicle.brandId === brandId);
    $('[data-model]').innerHTML = option('', brandId ? 'Modell wählen' : 'Zuerst Marke wählen') + models.map(model => option(model.id, model.label)).join('');
    $('[data-model]').disabled = !brandId;
    $('[data-model]').value = selected;
  }

  function brandOptions() {
    const brands = [...new Map(source.vehicles.map(vehicle => [vehicle.brandId, vehicle.brand])).entries()].sort((a, b) => a[1].localeCompare(b[1], 'de'));
    $('[data-brand]').innerHTML = option('', 'Alle Marken') + brands.map(([id, label]) => option(id, label)).join('');
  }

  function useFullCatalog(fitment) {
    const changed = source.vehicles.length !== fitment.vehicles.length || source.vehicles.some((vehicle, index) => {
      const next = fitment.vehicles[index];
      return ['id', 'brandId', 'brand', 'label'].some(field => vehicle[field] !== next[field]) ||
        vehicle.aliases.length !== next.aliases.length || vehicle.aliases.some((alias, i) => alias !== next.aliases[i]);
    });
    source = fitment;
    if (changed) { brandOptions(); reflectVehicle(); }
  }

  function reflectVehicle() {
    const vehicle = source.vehicles.find(value => value.id === state.vehicle);
    $('[data-active-vehicle]').hidden = !vehicle;
    $('[data-active-vehicle-name]').textContent = vehicle?.label || '';
    $('[data-vehicle-summary]').textContent = vehicle ? `Dein Scooter: ${vehicle.label} · ändern` : 'Deinen Scooter auswählen';
    $('[data-brand]').value = vehicle?.brandId || selectedBrand;
    vehicleOptions(vehicle?.brandId || selectedBrand, state.vehicle);
    pickers.forEach(picker => picker.sync());
    $('[data-vehicle-note]').textContent = vehicle ? `Passende Teile für ${vehicle.label}. Die Zuordnung gilt für genau dieses Modell.` :
      'Ohne Modellauswahl wird die Passform nicht geprüft. Wähle Marke und Modell für passende Teile.';
  }

  function reflectState() {
    $('#esv-query').value = state.query;
    reflectVehicle();
    $('[data-category]').value = state.category;
    $('[data-stock]').checked = state.stock;
    $('[data-sort]').value = state.sort;
  }

  function showGuide(step) {
    const panel = $('[data-guide]');
    const intro = $('.esv-search__intro');
    const searchForm = $('[data-search-form]');
    if (step === 'vehicle') $('[data-guide-search]').append(searchForm);
    else intro.prepend(searchForm);
    intro.hidden = step === 'vehicle';
    const home = step === 'category' && !state.query.trim() && !state.vehicle;
    root.classList.toggle('is-searching', !home);
    panel.classList.toggle('is-home', home);
    panel.classList.remove('is-expanded');
    $('[data-more-categories]').hidden = !home || categories.length <= 6;
    $('[data-more-categories]').setAttribute('aria-expanded', 'false');
    $('[data-more-categories]').textContent = 'Alle Kategorien anzeigen';
    $('[data-assist-banner]').hidden = Boolean(step) && !home;
    $('[data-assist-title]').textContent = home ? 'Du kennst das Problem, aber nicht das Teil?' : 'Noch nicht sicher?';
    $('[data-assist-description]').textContent = home ? 'Beschreibe, was an deinem Scooter nicht funktioniert.' : 'Beschreibe dein Problem. Deine Suche und Modellauswahl werden übernommen.';
    if (!$('[data-request-feedback]')) {
      $('[data-request-panel]').hidden = true;
      $('[data-request-open]').setAttribute('aria-expanded', 'false');
    }
    panel.hidden = !step;
    $('[data-search-layout]').hidden = Boolean(step);
    const keepEditing = $('[data-vehicle-home]').open && !state.vehicle && !step;
    $('[data-vehicle-home]').hidden = Boolean(step) || Boolean(state.vehicle);
    $('[data-vehicle-home]').open = keepEditing;
    $('[data-change-active-vehicle]').setAttribute('aria-expanded', String(editingVehicle));
    const vehicleControls = $('[data-vehicle-controls]');
    (step === 'vehicle' ? $('[data-guide-vehicle]') : $('[data-vehicle-home]')).append(vehicleControls);
    const category = categories.find(c => c.id === state.category);
    const kind = guide.kinds.find(k => k.id === state.tire);
    const info = guide.analyze(state, source, categories, core);
    const editable = !step && (kind || (!collectionHandle && category && !info.partQuery.trim()));
    $('[data-guide-selection]').hidden = !editable;
    $('[data-guide-selection-label]').textContent = kind?.label || category?.label || '';
    if (!step) return;
    const copy = {
      vehicle: ['Für welchen Scooter suchst du?', 'Wähle Marke und das genaue Modell. Du kannst auch ohne Modellauswahl weitersuchen.'],
      category: ['Welches Teil brauchst du?', state.vehicle ? 'Wähle jetzt die passende Teilekategorie.' : 'Starte mit einer Teilekategorie. Anschließend kannst du deinen Scooter auswählen.'],
      tire: ['Welche Reifenart suchst du?', 'Die Größe ist erkannt. Wähle die Bauart deines Reifens. Du kannst auch alle Reifenarten ansehen.']
    }[step];
    $('[data-guide-title]').textContent = home ? 'Direkt zur Teileart' : copy[0];
    const vehicle = source.vehicles.find(v => v.id === state.vehicle);
    $('[data-guide-description]').textContent = home ? 'Wähle eine Kategorie oder suche oben nach deinem Teil.' : (vehicle ? `Dein Scooter: ${vehicle.label}. ` : '') + copy[1];
    const choices = step === 'category' ? categories : step === 'tire' ? guide.kinds : [];
    $('[data-guide-choices]').innerHTML = choices.map(c => {
      const image = step === 'category' ? imageUrl(categoryImages[c.handle]) : '';
      return `<button class="esv-guide__choice" type="button" data-guide-choice="${escape(c.id)}" data-guide-step="${step}">${image ? `<img src="${escape(image)}" alt="" width="90" height="90" loading="lazy">` : ''}<strong>${escape(c.label)}</strong> <span aria-hidden="true">→</span></button>`;
    }).join('');
    $('[data-guide-skip]').textContent = step === 'vehicle' ? 'Ohne Modellauswahl weitersuchen' : step === 'tire' ? 'Alle Reifenarten ansehen' : 'Alle Teile ansehen';
    loading('');
    $('[data-results]').setAttribute('aria-busy', 'false');
    $('[data-grid]').replaceChildren();
    $('[data-pagination]').replaceChildren();
    $('[data-empty-help]').hidden = true;
    $('[data-result-controls]').disabled = true;
    $('[data-sort]').disabled = true;
  }

  function categoryTypes() {
    const group = categories.find(category => category.id === state.category);
    return group ? new Set([...group.legacyTypes, ...group.types.flatMap(type => [type.label, ...type.aliases])]) : null;
  }

  function typeOptions() {
    const allowed = categoryTypes();
    const types = [...new Set(groups.map(group => group.product.type).filter(type => type && (!allowed || allowed.has(type))))].sort((a, b) => a.localeCompare(b, 'de'));
    if (state.type && !types.includes(state.type)) state.type = '';
    $('[data-type]').innerHTML = option('', 'Alle Produkttypen') + types.map(type => option(type, type)).join('');
    $('[data-type]').value = state.type;
  }

  function productUrl(group) {
    const url = new URL(group.product.url, location.origin);
    if (url.origin !== location.origin || !url.pathname.includes('/products/')) throw new Error('Invalid product URL');
    url.searchParams.set('variant', group.variant.id);
    previewUrl(url);
    return url.href;
  }

  function imageUrl(value) {
    if (!value) return '';
    const url = new URL(value, location.origin);
    return url.protocol === 'https:' && (url.origin === location.origin || url.hostname === 'cdn.shopify.com') ? url.href : '';
  }

  function card(group) {
    const url = escape(productUrl(group));
    const vehicle = source.vehicles.find(value => value.id === state.vehicle);
    const models = group.models.map(id => source.vehicles.find(value => value.id === id)).filter(Boolean);
    const variantTitle = group.variant.title !== 'Default Title' ? ` · ${group.variant.title}` : '';
    const title = group.product.title + variantTitle;
    const image = imageUrl(group.variant.image);
    return `<article class="esv-card" data-article-key="${escape(group.key)}" data-sku="${escape(group.sku)}" data-variant="${group.variant.id}">
      <a class="esv-card__image" href="${url}" tabindex="-1" aria-hidden="true">${image ? `<img src="${escape(image)}" alt="" width="300" height="250" loading="lazy">` : '<span>Kein Bild vorhanden</span>'}</a>
      <div class="esv-card__body"><p class="esv-card__type">${escape(group.product.type || 'Ersatzteil')}</p>
      <h3><a href="${url}">${escape(title)}</a></h3>
      ${vehicle ? `<p class="esv-card__fit">✓ Passend für ${escape(vehicle.label)}</p>` : ''}
      ${models.length ? `<details><summary>Fahrzeugzuordnungen ansehen (${models.length})</summary><ul>${models.map(model => `<li>${escape(model.label)}</li>`).join('')}</ul></details>` : ''}
      <div class="esv-card__bottom">
      <p class="esv-card__stock ${group.variant.available ? '' : 'is-unavailable'}">${group.variant.available ? '● Verfügbar' : 'Zurzeit nicht verfügbar'}</p>
      <a class="esv-button esv-button--secondary" href="${url}">Zum Produkt ↗ <span class="visually-hidden">: ${escape(title)}</span></a>
      <p class="esv-card__sku">Artikelnummer ${escape(group.sku || '–')}</p></div></div></article>`;
  }

  function render() {
    typeOptions();
    const result = core.selectPage(groups, { ...state, types: categoryTypes() });
    state.page = result.page;
    $('[data-count]').textContent = `${result.count} Artikel`;
    $('[data-grid]').innerHTML = result.items.map(card).join('');
    $('[data-status]').classList.remove('is-error');
    $('[data-status]').textContent = result.count ? 'Preis und weitere Details findest du auf der Produktseite.' :
      state.vehicle ? 'Für diese Suche mit deinen Filtern ist derzeit kein passendes Teil für das gewählte Modell bestätigt. Du kannst die Filter ändern oder das Teil anfragen.' :
      'Keine Artikel für diese Suche und Filter gefunden. Versuche einen anderen Begriff oder ändere die Filter.';
    $('[data-empty-help]').hidden = result.count > 0;
    $('[data-empty-title]').textContent = state.vehicle ? 'Kein bestätigter Treffer für deinen Scooter.' : 'Gesuchtes Teil nicht gefunden?';
    $('[data-assist-banner]').hidden = result.count === 0;
    $('[data-pagination]').innerHTML = result.pages > 1 ? `<button type="button" data-page="${result.page - 1}" ${result.page === 1 ? 'disabled' : ''}>← Zurück</button><span>Seite ${result.page} von ${result.pages}</span><button type="button" data-page="${result.page + 1}" ${result.page === result.pages ? 'disabled' : ''}>Weiter →</button>` : '';
    loading('');
    $('[data-results]').setAttribute('aria-busy', 'false');
    $('[data-result-controls]').disabled = false;
    $('[data-sort]').disabled = false;
  }

  function fail() {
    $('.esv-search__intro').prepend($('[data-search-form]'));
    $('.esv-search__intro').hidden = false;
    root.classList.add('is-searching');
    $('[data-assist-banner]').hidden = true;
    $('[data-guide]').hidden = true;
    $('[data-search-layout]').hidden = false;
    $('[data-vehicle-home]').hidden = false;
    $('[data-empty-help]').hidden = true;
    $('[data-count]').textContent = 'Suche derzeit nicht vollständig verfügbar';
    $('[data-status]').classList.add('is-error');
    $('[data-status]').textContent = 'Die Ergebnisse konnten nicht vollständig geladen werden. Bitte lade die Seite erneut oder nutze die klassische Suche. Ob ein passendes Teil vorhanden ist, lässt sich gerade nicht zuverlässig prüfen.';
    loading('');
    $('[data-results]').setAttribute('aria-busy', 'false');
    $('[data-grid]').replaceChildren();
    $('[data-pagination]').replaceChildren();
    $('[data-result-controls]').disabled = true;
    $('[data-sort]').disabled = true;
  }

  async function search({ detect = false, replace = false, reuse = false } = {}) {
    const current = ++sequence;
    controller?.abort();
    controller = new AbortController();
    try {
      // SKU and model recognition need the complete catalogue for typed queries.
      if (source.provisional && state.query.trim()) {
        loading('Unser Sortiment wird durchsucht …');
        const fitment = await fullCatalog;
        if (current !== sequence) return;
        source = fitment;
      }
      const resolved = core.resolveVehicle(state.query, source.vehicles);
      const knownSku = Object.hasOwn(source.skus, core.skuKey(state.query));
      if (detect && knownSku) {
        state.vehicle = ''; selectedBrand = ''; state.category = ''; state.family = ''; state.tire = '';
      } else if (detect && resolved) {
        state.vehicle = resolved.vehicle.id; state.vehicleOff = false;
        rememberVehicle();
      }
      if (collectionCategory) state.category = collectionCategory.id;
      const info = guide.analyze(state, source, categories, core);
      if (detect && !state.category && info.intent) {
        state.category = info.intent.category; state.family = info.intent.family;
      }
      reflectState();
      syncUrl(replace);
      const nextStep = editingVehicle ? 'vehicle' : guide.step(state, info);
      showGuide(nextStep);
      if (nextStep) return;
      const query = info.partQuery;
      $('[data-results]').setAttribute('aria-busy', 'true');
      $('[data-count]').textContent = 'Wir suchen dein Teil …';
      loading('Unser Sortiment wird durchsucht …');
      $('[data-status]').classList.remove('is-error');
      $('[data-status]').textContent = 'Einen Moment bitte.';
      $('[data-empty-help]').hidden = true;
      $('[data-grid]').replaceChildren();
      $('[data-pagination]').replaceChildren();
      $('[data-result-controls]').disabled = true;
      $('[data-sort]').disabled = true;
      if (source.provisional) {
        const fitment = await fullCatalog;
        if (current !== sequence) return;
        source = fitment;
      }
      if (state.vehicle && !source.vehicles.some(vehicle => vehicle.id === state.vehicle)) throw new Error('Unknown model');
      const signal = controller.signal;
      const searchQuery = window.EsvShopifyCatalog.restrictQuery(guide.catalogueQuery(state, info, categories, core), source, state.vehicle);
      const request = async (document, variables) => {
        const response = await fetch('/api/2026-07/graphql.json', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ query: document, variables }),
          signal: AbortSignal.any([signal, AbortSignal.timeout(30000)])
        });
        if (!response.ok) throw new Error('Product request failed');
        const payload = await response.json();
        if (payload.errors?.length || !payload.data) throw new Error('Incomplete product response');
        return payload.data;
      };
      const context = { country: root.dataset.country || 'DE', language: root.dataset.language || 'DE', currency };
      const [loadedProducts, membership] = await Promise.all([
        reuse && cached?.query === searchQuery ? cached.products : window.EsvSearchStorefront.loadProducts(request, { ...context, query: searchQuery }, () => {
          if (current === sequence) $('[data-loading-message]').textContent = 'Weitere Ersatzteile werden geladen …';
        }),
        collectionHandle && !collectionIds ? window.EsvSearchStorefront.loadCollectionIds(request, { ...context, handle: collectionHandle }) : collectionIds
      ]);
      if (current !== sequence) return;
      products = loadedProducts.map(product => {
        const record = source.records[String(product.id)];
        if (!record) throw new Error('Shopify listing changed; reload catalogue');
        return { ...product, models: source.productModels[String(product.id)].map(id => source.vehicles.find(v => v.id === id).label), brands: record.brands || [], condition: record.condition || '' };
      });
      collectionIds = membership;
      cached = { query: searchQuery, products };
      const exactSku = products.some(product => product.variants.some(variant => core.skuKey(variant.sku) === core.skuKey(query))) ? query : '';
      const allowed = guide.allowedTypes(state, categories);
      const candidates = products.filter(p => (!allowed || allowed.has(guide.key(p.type))) && (!collectionIds || collectionIds.has(p.id)));
      $('[data-loading-message]').textContent = 'Passende Teile werden zusammengestellt …';
      groups = core.rankGroups(core.groupProducts(candidates, source, state.vehicle, exactSku), query);
      render();
      syncUrl(true);
    } catch (_error) {
      if (current !== sequence) return;
      if (_error.message === 'Shopify listing changed; reload catalogue' && !refreshed) {
        refreshed = true;
        try {
          window.EsvShopifyCatalog.invalidate();
          const fitment = await window.EsvShopifyCatalog.load();
          if (current !== sequence) return;
          if (!validFitment(fitment)) throw new Error('Invalid catalogue');
          useFullCatalog(fitment);
          await search({ replace: true });
          return;
        } catch (_) { /* Fall through to the existing error state. */ }
      }
      if (current === sequence) { controller.abort(); fail(); }
    }
  }

  function filterChange() {
    state.page = 1;
    render();
    syncUrl();
  }

  function validFitment(fitment) {
    return fitment?.version === 2 && fitment.productModels && fitment.variantSkus && fitment.skus && Array.isArray(fitment.vehicles) &&
      fitment.vehicles.every(vehicle => vehicle.id && vehicle.brandId && vehicle.brand && vehicle.label && Array.isArray(vehicle.aliases));
  }

  async function boot() {
    readState();
    updateNative();
    if (state.inquiry) { loading(''); showVehicleInquiry(); return; }
    loading('Fahrzeuge und Teilekategorien werden geladen …');
    $('[data-filters]').open = matchMedia('(min-width: 750px)').matches;
    try {
      fullCatalog = window.EsvShopifyCatalog.load().then(fitment => {
        if (!validFitment(fitment)) throw new Error('Invalid catalogue');
        return fitment;
      });
      fullCatalog.catch(() => {});
      const [vehicles, parts] = await Promise.all([state.query.trim() ? null : window.EsvShopifyCatalog.loadVehicles(), json(root.dataset.groupsUrl)]);
      if (!Array.isArray(parts.groups) || !parts.groups.length) throw new Error('Invalid catalogue');
      source = vehicles ? { version: 2, provisional: true, vehicles, productModels: {}, records: {}, skus: {}, variantSkus: {}, variantConditions: {} } : await fullCatalog;
      // Resolve remembered scooters only against the complete catalogue, including models absent from the file.
      if (source.provisional) {
        let remembered = false;
        try {
          const session = sessionStorage.getItem(vehicleSessionKey);
          const garage = session === null ? JSON.parse(localStorage.getItem('evscooter:garage:v1')) : null;
          remembered = Boolean(session || (garage?.brandName && garage?.variantName));
        } catch (_) { /* The manual picker still works. */ }
        if (state.vehicle || (!state.vehicleOff && remembered)) source = await fullCatalog;
      }
      categories = parts.groups;
      if (collectionHandle) {
        collectionCategory = categories.find(category => category.handle === collectionHandle);
        if (!collectionCategory) throw new Error('Unknown parts collection');
        $('[data-category]').closest('label').hidden = true;
        $('.esv-search__examples').hidden = true;
        $('#esv-query').placeholder = 'In dieser Kategorie suchen';
      }
      brandOptions();
      $('[data-category]').innerHTML = option('', 'Alle Kategorien') + categories.map(category => option(category.id, category.label)).join('');
      $('[data-vehicle-controls]').disabled = false;
      if (state.vehicle && !source.vehicles.some(v => v.id === state.vehicle)) {
        state.vehicle = ''; state.vehicleOff = true;
        window.EsvPartsVehicle?.set('');
      }
      const explicitVehicle = Boolean(state.vehicle);
      if (!state.vehicle && !state.vehicleOff && !Object.hasOwn(source.skus, core.skuKey(state.query))) {
        try {
          const remembered = sessionStorage.getItem(vehicleSessionKey);
          const saved = remembered !== null ? source.vehicles.find(vehicle => vehicle.id === remembered) :
            guide.savedVehicle(JSON.parse(localStorage.getItem('evscooter:garage:v1')), source.vehicles);
          if (saved) state.vehicle = saved.id;
        } catch (_) { /* Storage may be unavailable; the manual picker still works. */ }
      }
      if (state.vehicle && source.vehicles.some(vehicle => vehicle.id === state.vehicle)) rememberVehicle();
      bind();
      if (window.EsvSearchPicker) {
        pickers.push(window.EsvSearchPicker.attach($('[data-brand]'), 'brand'), window.EsvSearchPicker.attach($('[data-model]'), 'model'));
      }
      if (source.provisional) fullCatalog.then(useFullCatalog).catch(() => {});
      await search({ detect: !explicitVehicle, replace: true });
    } catch (_error) { fail(); }
  }

  // This entry works even if the catalogue cannot load. It makes no fitment claim.
  function showVehicleInquiry() {
    updateRequest();
    root.classList.add('is-vehicle-inquiry');
    ['[data-vehicle-home]', '.esv-search__fallback', '[data-guide]', '[data-search-layout]', '[data-active-vehicle]', '[data-assist-banner]', '.esv-search__intro'].forEach(selector => { $(selector).hidden = true; });
    $('[data-request-panel]').hidden = false;
    $('#esv-request-title').textContent = 'Scooter oder Ersatzteil anfragen';
    const back = new URL(root.dataset.searchUrl, location.origin);
    previewUrl(back);
    back.searchParams.set('esv_vehicle_off', '1');
    const close = $('[data-request-close]');
    if (close) { close.textContent = 'Zur Teileauswahl'; close.addEventListener('click', () => location.assign(back.href)); }
    const heading = $('[data-request-feedback]') || $('#esv-request-title');
    heading.tabIndex = -1; heading.focus({ preventScroll: true });
  }

  function bind() {
    $('[data-change-active-vehicle]').addEventListener('click', async () => {
      editingVehicle = !editingVehicle;
      await search({ reuse: true });
      if (editingVehicle) ($('#esv-picker-model') || $('[data-model]')).focus();
    });
    $('[data-remove-active-vehicle]').addEventListener('click', () => $('[data-clear-vehicle]').click());
    $('[data-request-open]').addEventListener('click', () => {
      updateRequest();
      $('[data-request-panel]').hidden = false;
      $('[data-request-open]').setAttribute('aria-expanded', 'true');
      ($('#esv-request-email') || $('[data-request-feedback]')).focus();
    });
    $('[data-request-close]')?.addEventListener('click', () => {
      $('[data-request-panel]').hidden = true;
      $('[data-request-open]').setAttribute('aria-expanded', 'false');
      $('[data-request-open]').focus();
    });
    $('[data-more-categories]').addEventListener('click', () => {
      const expanded = $('[data-guide]').classList.toggle('is-expanded');
      $('[data-more-categories]').setAttribute('aria-expanded', String(expanded));
      $('[data-more-categories]').textContent = expanded ? 'Weniger Kategorien anzeigen' : 'Alle Kategorien anzeigen';
    });
    root.querySelectorAll('[data-search-example]').forEach(button => {
      button.disabled = false;
      button.addEventListener('click', () => {
        $('#esv-query').value = button.dataset.searchExample;
        $('[data-search-form]').requestSubmit();
      });
    });
    $('[data-guide-choices]').addEventListener('click', event => {
      const button = event.target.closest('[data-guide-choice]');
      if (!button) return;
      if (button.dataset.guideStep === 'category') {
        state.category = button.dataset.guideChoice; state.family = ''; state.tire = '';
      } else {
        state.tire = button.dataset.guideChoice;
        state.category = guide.tireCategory(categories)?.id || ''; state.family = '';
      }
      state.type = ''; state.page = 1; state.skipGuide = false;
      search({ reuse: true });
    });
    $('[data-guide-skip]').addEventListener('click', () => {
      if (editingVehicle) {
        selectedBrand = ''; state.vehicle = ''; state.vehicleOff = true; rememberVehicle();
      }
      editingVehicle = false; state.skipGuide = true; state.page = 1; search({ reuse: true });
    });
    $('[data-guide-edit]').addEventListener('click', () => {
      state.tire = ''; state.family = ''; state.category = ''; state.type = ''; state.skipGuide = false; state.page = 1;
      search({ reuse: true });
    });
    root.querySelectorAll('[data-ask-ai]').forEach(link => link.addEventListener('click', event => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const widget = document.querySelector('[data-ai-chat]');
      const toggle = widget?.querySelector('[data-ai-chat-toggle]');
      const panel = widget?.querySelector('[data-ai-chat-panel]');
      const input = widget?.querySelector('[data-ai-chat-input]');
      if (!toggle || !panel || !input || input.disabled) return;
      if (panel.getAttribute('data-open') !== 'true') toggle.click();
      if (panel.getAttribute('data-open') !== 'true') return;
      event.preventDefault();
      const vehicle = source.vehicles.find(value => value.id === state.vehicle);
      const filters = [categories.find(category => category.id === state.category)?.label, state.type,
        state.stock ? 'nur verfügbare Teile' : ''].filter(Boolean);
      input.value = core.aiSearchPrompt(state.query, vehicle, filters);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.focus();
    }));
    $('[data-search-form]').addEventListener('submit', event => {
      event.preventDefault();
      state.query = $('#esv-query').value.trim();
      editingVehicle = false;
      state.category = ''; state.type = ''; state.family = ''; state.tire = ''; state.skipGuide = false;
      state.page = 1;
      search({ detect: true });
    });
    $('[data-brand]').addEventListener('change', () => {
      selectedBrand = $('[data-brand]').value;
      const resolved = core.resolveVehicle(state.query, source.vehicles);
      if (resolved) state.query = resolved.query;
      state.vehicle = ''; state.vehicleOff = true;
      rememberVehicle();
      state.page = 1;
      search({ reuse: true });
    });
    $('[data-model]').addEventListener('change', () => {
      const resolved = core.resolveVehicle(state.query, source.vehicles);
      if (resolved) state.query = resolved.query;
      state.vehicle = $('[data-model]').value; state.vehicleOff = !state.vehicle; state.page = 1;
      editingVehicle = false;
      rememberVehicle(); search({ reuse: true });
    });
    $('[data-clear-vehicle]').addEventListener('click', () => {
      editingVehicle = false;
      const resolved = core.resolveVehicle(state.query, source.vehicles);
      if (resolved) state.query = resolved.query;
      selectedBrand = ''; state.vehicle = ''; state.vehicleOff = true; state.page = 1; search({ reuse: true });
      rememberVehicle();
    });
    $('[data-category]').addEventListener('change', () => { state.category = $('[data-category]').value; state.type = ''; state.family = ''; state.tire = ''; state.page = 1; search({ reuse: true }); });
    $('[data-type]').addEventListener('change', () => { state.type = $('[data-type]').value; filterChange(); });
    $('[data-stock]').addEventListener('change', () => { state.stock = $('[data-stock]').checked; filterChange(); });
    $('[data-sort]').addEventListener('change', () => { state.sort = $('[data-sort]').value; filterChange(); });
    $('[data-reset-filters]').addEventListener('click', () => {
      state.category = ''; state.type = ''; state.family = ''; state.tire = ''; state.stock = false; state.sort = 'relevance'; state.page = 1;
      search({ reuse: true });
    });
    $('[data-pagination]').addEventListener('click', event => {
      const button = event.target.closest('[data-page]');
      if (!button || button.disabled) return;
      state.page = Number(button.dataset.page); render(); syncUrl();
      $('[data-count]').setAttribute('tabindex', '-1');
      $('[data-count]').focus({ preventScroll: true });
      $('[data-results]').scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    document.addEventListener('garage:change', () => {
      editingVehicle = false;
      if (Object.hasOwn(source.skus, core.skuKey(state.query))) return;
      let vehicle = null;
      try { vehicle = guide.savedVehicle(JSON.parse(localStorage.getItem('evscooter:garage:v1')), source.vehicles); } catch (_) { /* Manual selection remains available. */ }
      const resolved = core.resolveVehicle(state.query, source.vehicles);
      if (resolved) state.query = resolved.query;
      state.vehicle = vehicle?.id || ''; state.vehicleOff = !vehicle; selectedBrand = ''; state.page = 1;
      rememberVehicle();
      search({ reuse: true });
    });
    document.addEventListener('esv:vehicle-change', event => {
      if (event.detail.origin === 'results' || event.detail.origin === 'url' ||
          Object.hasOwn(source.skus, core.skuKey(state.query))) return;
      const vehicle = source.vehicles.find(value => value.id === event.detail.id);
      const resolved = core.resolveVehicle(state.query, source.vehicles);
      if (resolved) state.query = resolved.query;
      editingVehicle = false; selectedBrand = '';
      state.vehicle = vehicle?.id || ''; state.vehicleOff = !vehicle; state.page = 1;
      search({ reuse: true });
    });
    window.addEventListener('popstate', () => { editingVehicle = false; readState(); search({ replace: true }); });
  }
  boot();
})();
